"use client";

import { ChevronRight, ShieldCheck, Lock, CreditCard } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Checkout() {
  const breadcrumbSteps = [{
    label: "CART",
    to: "/CartPage",
    active: false
  }, {
    label: "CHECKOUT",
    to: "/CheckoutPage",
    active: true
  }, {
    label: "CONFIRMATION",
    to: "#",
    active: false
  }];
  const trustBadges = [{
    id: 1,
    label: "SSL ENCRYPTED",
    icon: Lock
  }, {
    id: 2,
    label: "SECURE PAYMENT",
    icon: ShieldCheck
  }, {
    id: 3,
    label: "VERIFIED CHECKOUT",
    icon: CreditCard
  }];
  return <section data-section-id="2156" id="checkout-content" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" aria-hidden="true">
        <div className="absolute inset-y-0 left-1/4 w-px bg-foreground" />
        <div className="absolute inset-y-0 left-1/2 w-px bg-foreground" />
        <div className="absolute inset-y-0 left-3/4 w-px bg-foreground" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        {}
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-6">
            <span className="font-mono text-xs uppercase tracking-widest" style={{
            color: "var(--primary)"
          }}>
              [ CHECKOUT / 02 ]
            </span>
            <div className="h-px flex-1 max-w-[120px]" style={{
            backgroundColor: "var(--border)"
          }} />
            <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
              LSH-FA / 48.8566° N / 2.3522° E
            </span>
          </div>

          <h1 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold uppercase leading-[0.9] tracking-tighter">
            <span className="block">FINALIZE</span>
            <span className="block" style={{
            WebkitTextStroke: "1px var(--foreground)",
            color: "transparent"
          }}>
              YOUR ORDER
            </span>
          </h1>
        </div>

        {}
        <div className="mb-12 md:mb-16">
          <nav aria-label="Checkout progress">
            <ol className="flex flex-wrap items-center gap-2 md:gap-3 font-mono text-[10px] md:text-xs uppercase tracking-widest">
              {breadcrumbSteps.map((step, i) => <li key={step.label} data-index={i} className="flex items-center gap-2 md:gap-3">
                  {step.active ? <span className="px-2 py-1 border" style={{
                color: "var(--primary)",
                borderColor: "var(--primary)",
                backgroundColor: "var(--accent)"
              }}>
                      {step.label}
                    </span> : <Link to={step.to} className="text-muted-foreground hover:text-foreground transition-colors px-2 py-1">
                      {step.label}
                    </Link>}
                  {i < breadcrumbSteps.length - 1 && <span className="inline-flex items-center justify-center w-4 h-4 border" style={{
                borderColor: "var(--border)"
              }} aria-hidden="true">
                      <ChevronRight className="w-3 h-3 text-muted-foreground" />
                    </span>}
                </li>)}
            </ol>
          </nav>
          <div className="mt-6 h-px w-full" style={{
          backgroundColor: "var(--border)"
        }} />
        </div>

        {}
        <div className="mb-8 flex items-center gap-3">
          <span className="font-mono text-xs uppercase tracking-widest" style={{
          color: "var(--primary)"
        }}>
            01 /
          </span>
          <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
            BILLING DETAILS
          </span>
          <div className="h-px flex-1" style={{
          backgroundColor: "var(--border)"
        }} />
        </div>

        {}
        <div className="relative border backdrop-blur-sm p-4 sm:p-6 md:p-10" style={{
        borderColor: "var(--border)",
        backgroundColor: "var(--card)",
        boxShadow: "var(--shadow-lg)"
      }}>
          {`<!-- wp:woocommerce/checkout --><!-- /wp:woocommerce/checkout -->`}
        </div>

        {}
        <div className="mt-6 flex items-center justify-center gap-2 font-mono text-[10px] md:text-xs uppercase tracking-widest text-muted-foreground">
          <Lock className="w-3 h-3" />
          <span>SECURE ATELIER CHECKOUT</span>
        </div>

        {}
        <div className="mt-16 pt-10 border-t" style={{
        borderColor: "var(--border)"
      }}>
          <div className="flex items-center gap-3 mb-6">
            <span className="font-mono text-xs uppercase tracking-widest" style={{
            color: "var(--primary)"
          }}>
              02 /
            </span>
            <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
              PROTECTION
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-px" style={{
          backgroundColor: "var(--border)"
        }}>
            {trustBadges.map((badge, i) => {
            const Icon = badge.icon;
            return <div key={badge.id} data-index={i} className="flex items-center justify-center gap-3 py-6 px-4" style={{
              backgroundColor: "var(--background)"
            }}>
                  <Icon className="w-4 h-4" style={{
                color: "var(--primary)"
              }} />
                  <span className="font-mono text-xs uppercase tracking-widest text-foreground">
                    {badge.label}
                  </span>
                </div>;
          })}
          </div>
        </div>

        {}
        <div className="mt-10 flex items-center justify-between font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
          <span>DRIP DISTRICT / DIGITAL ATELIER</span>
          <span>EST. 2024</span>
        </div>
      </div>
    </section>;
}